var _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoLv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "latvia-svgrepo-com",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#f0f0f0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1644",
    "data-name": "Group 1644"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5265",
    "data-name": "Path 5265",
    d: "M18,0A18.007,18.007,0,0,0,.62,13.3H35.38A18.007,18.007,0,0,0,18,0Z",
    fill: "#a2001d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5266",
    "data-name": "Path 5266",
    d: "M18,36A18.007,18.007,0,0,0,35.38,22.7H.62A18.007,18.007,0,0,0,18,36Z",
    fill: "#a2001d"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLv);
export default __webpack_public_path__ + "static/media/ico_lv.120770b9b89691e3dc0ee341e875dfb4.svg";
export { ForwardRef as ReactComponent };